<template>
    <div>
     <!--  {{users}}
      
      <pre>{{payoutData}}</pre> -->

 <vs-table
            class="cstm_vuexy_table mt-2"
            
            :data="payoutData"
          >
            <template slot="thead">
              <vs-th style="min-width: 80px;" sort-key="s_name"> Image </vs-th>
              <vs-th style="min-width: 80px;" sort-key="s_name"> Staff Name </vs-th>
              <vs-th style="min-width: 80px;" sort-key="pay_freq"> Payment Frequency </vs-th>
              <vs-th style="min-width: 145px;" sort-key="guar_work_hour">
                Guaranteed Working Hours
              </vs-th>
              <vs-th style="min-width: 108px;" sort-key="total_hour"> Total Hour of Work </vs-th>
              <vs-th sort-key="hour_pay"> Hourly Payment </vs-th>
              <vs-th sort-key="total_pay"> Total Payments </vs-th>
              <vs-th sort-key="pay_duration"> Payment Duration </vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr"
              :key="indextr"
               v-for="(tr, indextr) in data">
               
                <vs-td :data="data[indextr].staff_picture">
                   <img
                    v-if="data[indextr].staff_picture"
                    class="person-img rounded-full"
                    :src="data[indextr].staff_picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                </vs-td>
                
                <vs-td :data="data[indextr].staff_name">
                  {{ data[indextr].staff_name }}
                </vs-td>

                <vs-td :data="data[indextr].payment_frequency">
                  {{ data[indextr].payment_frequency }}
                </vs-td>

                <vs-td :data="data[indextr].guaranteed_hour">
                  {{ data[indextr].guaranteed_hour }}
                </vs-td>

                <vs-td :data="data[indextr].total_hour_of_work">
                  {{ data[indextr].total_hour_of_work }}
                </vs-td>

                <vs-td :data="data[indextr].hourly_payment">
                  {{ data[indextr].hourly_payment }}
                </vs-td>
                <!-- <vs-td :data="data[indextr].hour_pay">
                  {{ data[indextr].hour_pay }}
                </vs-td> -->

                <vs-td :data="data[indextr].total_payment">
                  {{ data[indextr].total_payment }}
                </vs-td>
                <vs-td :data="data[indextr].total_payment">
                  {{ $moment(dateRange.startDate).format(
            'YYYY-MM-DD') }} &nbsp; to &nbsp;{{ $moment(dateRange.endDate).format(
            'YYYY-MM-DD') }}
                </vs-td>
                
              </vs-tr>
            </template>
          </vs-table>

          <div class="flex items-center justify-between mt-4">
            <vs-button type="border" @click="$emit('closePayrange', 'back')">Back</vs-button>
            <vs-button @click="getPayoutCreate(true)"
            >Pay</vs-button>
          </div>
    </div>
</template>

<script>
import {createPayout} from '@/api/finance'
export default {
  props:{
    users:{},
    dateRange:{}
  },
  data () {
    return {
      payoutData:[]
    }
  },
  created () {
    this.getPayoutCreate()
  },
  watch:{
    dateRange:{
      deep:true,
      handler () {
        this.getPayoutCreate()
      }
    }
  },
  methods:{
    async getPayoutCreate (save = false) {
      try {
        const payload = {
          'users': this.users,
          'from_date': this.$moment(this.dateRange.startDate).format(
            'YYYY-MM-DD'
          ),
          'to_date': this.$moment(this.dateRange.endDate).format(
            'YYYY-MM-DD'
          ),
          save
        }
        const customer_id = localStorage.getItem('customer_id')
        const data = await createPayout(customer_id, payload)
        this.payoutData = data.data.data
        if (save) {
          this.showSuccessMessage('Success', 'Pay Out Generated Successfully', 'success')
          this.$emit('closePayrange')
        }
        console.log(data)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>